import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useAxios } from '../../utils/hook/useAxios';

/* ---------- Données d'affichage (valeurs identiques à l'existant) ---------- */

const KM_OPTIONS = [
  ['0', '0-15 000 km'],
  ['1', '15-50 000 km'],
  ['2', '50-100 000 km'],
  ['3', '100-150 000 km'],
  ['4', '150-200 000 km'],
  ['5', '+200 000 km'],
];

const FUEL_OPTIONS = [
  ['0', 'Électricité'],
  ['1', 'Diesel'],
  ['2', 'Gazole'],
  ['3', 'Hydrogène'],
];

const DOOR_OPTIONS = [
  ['1', '2'],
  ['2', '3'],
  ['3', '4'],
  ['4', '5'],
  ['5', '6'],
  ['6', '7+'],
];

const SEAT_OPTIONS = [
  ['1', '2'],
  ['2', '3'],
  ['3', '4'],
  ['4', '5'],
  ['5', '6'],
  ['6', '7'],
  ['7', '8'],
  ['8', '9+'],
];

const EXTRA_OPTIONS = [
  { id: '1', label: 'Climatisation', icon: 'snow-outline' },
  { id: '2', label: 'Régulateur de vitesse', icon: 'speedometer-outline' },
  { id: '3', label: 'GPS', icon: 'navigate-circle-outline' },
  { id: '4', label: 'Siège bébé', icon: 'egg-outline' },
  { id: '5', label: 'Coffre de toit', icon: 'cube-outline' },
  { id: '6', label: 'Porte-vélos', icon: 'bicycle-outline' },
  { id: '7', label: 'Pneus neige', icon: 'snow-outline' },
  { id: '8', label: 'Chaînes', icon: 'link-outline' },
  { id: '9', label: 'Porte-skis', icon: 'trail-sign-outline' },
  { id: '10', label: 'Entrée audio iPod', icon: 'musical-notes-outline' },
  { id: '11', label: 'Audio Bluetooth', icon: 'bluetooth-outline' },
  { id: '12', label: 'Attelage', icon: 'git-merge-outline' },
  { id: '13', label: 'Accessible fauteuil roulant', icon: 'accessibility-outline' },
  { id: '14', label: 'Apple CarPlay', icon: 'logo-apple' },
  { id: '15', label: 'Android Auto', icon: 'logo-android' },
];

const STEP_LABELS = ['Caractéristiques', 'Options', 'Photos et facturation'];

/* ---------- Petits composants de présentation ---------- */

function Choice({ type = 'radio', variant = '', id, name, value, checked, onChange, children }) {
  return (
    <div className={`mc-choice ${variant}`.trim()}>
      <input type={type} id={id} name={name} value={value} checked={checked} onChange={onChange} />
      <label htmlFor={id}>{children}</label>
    </div>
  );
}

function Stepper({ current }) {
  return (
    <div className="mc-stepper">
      <div className="mc-stepper-top">
        <span>Inscrire ma voiture</span>
        <span>
          Étape {current + 2} sur 4 · {STEP_LABELS[current]}
        </span>
      </div>
      <div
        className="mc-stepper-bar"
        role="progressbar"
        aria-valuenow={(current + 2) * 25}
        aria-valuemin="0"
        aria-valuemax="100"
      >
        <div className="mc-stepper-fill" style={{ width: `${(current + 2) * 25}%` }}></div>
      </div>
    </div>
  );
}

function SafetyAlert() {
  return (
    <div className="mc-form-alert" role="note">
      <ion-icon name="shield-checkmark-outline"></ion-icon>
      <span>
        Ces informations nous permettent d'assurer la sécurité et la qualité de notre flotte.
      </span>
    </div>
  );
}

/* ---------- Page ---------- */

function AdvancedConfigPage() {
  const [displayArray, setDisplayArray] = useState([true, false, false]);
  const [selectedCarburant, setSelectedCarburant] = useState(null);
  const [selectedKilometrage, setSelectedKilometrage] = useState(null);
  const [vitesse, setVitesse] = useState('1');
  const [isUtilitaire, setIsUtilitaire] = useState(null);

  const [nombrePorte, setNombrePorte] = useState('4');
  const [nombreSiege, setNombreSiege] = useState('5');
  const [vehicleData, setVehicleData] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [file, setFile] = useState([]);
  const [fileName, setFileName] = useState('');
  const [optionsCachees, setOptionsCachees] = useState([]);
  const [carsImages, setCarsImages] = useState('');
  const axios = useAxios();
  const { voitureId } = useParams();
  const userData = JSON.parse(window.localStorage.getItem('me'));

  // Fonctions de rappel pour récupérer les valeurs sélectionnées
  useEffect(() => {
    let fetchReviews = async () => {
      let datavehicule = window.localStorage.getItem('VehicleStorage');
      datavehicule = JSON.parse(datavehicule);

      setVehicleData(datavehicule);
      setSelectedKilometrage(datavehicule.kilometrage);
      if (datavehicule.siegeNumber) setNombreSiege(datavehicule.siegeNumber);
      if (datavehicule.porteNumber) setNombrePorte(datavehicule.porteNumber);
      if (datavehicule.vitesseType) setVitesse(datavehicule.vitesseType);
      setIsUtilitaire(datavehicule.IsUtilitaire);
    };
    fetchReviews();
  }, []);

  const [options, setOptions] = useState([]);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [checkedOptions, setCheckedOptions] = useState(Array(15).fill(false));
  useEffect(() => {
    let fetchReviews = async () => {
      const response = await axios.get(`/vehicleOptionRecords/${voitureId}`);
      setOptions(response.data);

      setSelectedOptions(response.data.map((option) => option.vehiculeOptionId));

      const newCheckedOptions = Array(15).fill(false);
      response.data.forEach((option) => {
        const index = option.vehiculeOptionId - 1;
        if (index >= 0 && index < 15) {
          newCheckedOptions[index] = true;
        }
      });
      setCheckedOptions(newCheckedOptions);
    };
    fetchReviews();
  }, []);

  const isChecked = (id) => selectedOptions.includes(id);

  function handleNext1() {
    const data = {
      selectedCarburant: selectedCarburant,
      selectedKilometrage: selectedKilometrage,
      nombrePorte: nombrePorte,
      nombreSiege: nombreSiege,
      vitesse: vitesse,
    };

    let datavehicule = { ...vehicleData };
    datavehicule.kilometrage = selectedKilometrage;
    datavehicule.carburantType = selectedCarburant;
    datavehicule.vitesseType = vitesse;
    datavehicule.porteNumber = nombrePorte;
    datavehicule.siegeNumber = nombreSiege;
    datavehicule.IsUtilitaire = isUtilitaire;
    datavehicule = JSON.stringify(datavehicule);
    setVehicleData(datavehicule);

    window.localStorage.setItem('VehicleStorage', datavehicule);

    console.log('data', datavehicule);
    setDisplayArray([false, true, false]);
  }

  function handleNext2() {
    let DataVehicle = JSON.parse(vehicleData);
    const envoyerRequete = async (data) => {
      try {
        const response = await axios.post('/vehicleOptionRecords', {
          vehiculeId: DataVehicle.id,
          vehiculeOptionId: data,
        });
        const res = await axios.put('/vehicles/' + DataVehicle.id, {
          vehiculeId: DataVehicle.id,
          modeleId: DataVehicle.modeleId,
          kilometrage: DataVehicle.kilometrage,
          carburantType: DataVehicle.carburantType,
          vitesseType: DataVehicle.vitesseType,
          porteNumber: DataVehicle.porteNumber,
          siegeNumber: DataVehicle.siegeNumber,
          annee: DataVehicle.annee,
          CoordonatesCity: DataVehicle.CoordonatesCity,
          IsUtilitaire: isUtilitaire,
        });
        console.log('Réponse du serveur:', response.data);
        return response.data;
      } catch (error) {
        console.error('Erreur de requête:', error);
        throw error;
      }
    };

    // Utilisez map pour créer un tableau de promesses pour chaque ensemble de données
    const promessesRequetes = optionsCachees.map(envoyerRequete);

    // Utilisez Promise.all pour attendre l'achèvement de toutes les promesses
    Promise.all(promessesRequetes)
      .then((resultats) => {
        console.log('Toutes les requêtes ont été complétées :', resultats);
      })
      .catch((erreur) => {
        console.error("Une erreur s'est produite lors des requêtes :", erreur);
      });

    setDisplayArray([false, false, true]);
  }

  function handlePreced1() {
    window.location.href = '/confirmmodel/' + voitureId;
  }

  function handlePreced2() {
    setDisplayArray([true, false, false]);
  }

  function handlePreced3() {
    setDisplayArray([false, true, false]);
  }

  const handleCarburantChange = (event) => {
    setSelectedCarburant(event.target.value);
  };

  const handleKmChange = (event) => {
    setSelectedKilometrage(event.target.value);
  };

  const handleSpeedChange = (event) => {
    setVitesse(event.target.value);
  };

  const handleIsUtilitaireChange = (event) => {
    setIsUtilitaire(event.target.value);
  };

  const handleNbPorteChange = (e) => setNombrePorte(e.target.value);
  const handleSiegeChange = (e) => setNombreSiege(e.target.value);

  const handleCheckBoxChange = (event) => {
    const value = event.target.value;
    const isChecked = event.target.checked;

    const index = parseInt(value) - 1;

    // Mettre à jour l'état checkedOptions
    setCheckedOptions((prev) => {
      const newCheckedOptions = [...prev];
      newCheckedOptions[index] = isChecked;
      return newCheckedOptions;
    });

    // Mettre à jour l'état local en fonction des cases à cocher sélectionnées
    if (isChecked) {
      setOptionsCachees((prevOptions) => [...prevOptions, value]);
    } else {
      setOptionsCachees((prevOptions) => prevOptions.filter((option) => option !== value));
    }
  };

  const [formData, setFormData] = useState({
    adresse: '',
    codePostal: '',
    ville: '',
    pays: '1', // France par défaut
    numeroTelephone: '',
  });

  // Gestionnaire pour mettre à jour le state lorsqu'un champ change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  // Gestionnaire pour soumettre le formulaire (vous pouvez ajouter votre logique de soumission ici)
  const handleSubmit = (e) => {
    e.preventDefault();
    // Créez une fonction pour envoyer une requête pour un ensemble de données
    let fetchAddresses = async () => {
      const response = await axios.post('/facturationAddress/', {
        adresse: formData.adresse,
        postalCode: formData.codePostal,
        ville: formData.ville,
        pays: formData.pays,
        phoneNumber: formData.phoneNumber,
        userId: userData.id,
      });
      if (response.data) {
        console.log(response.data);
        window.location.href = '/completeAnnonce';
      }
    };
    fetchAddresses();
  };
  const [imagereview, setImagereview] = useState([]);

  const [isDragging, setIsDragging] = useState(false);

  // Envoie chaque image à Cloudinary et crée sa miniature (sélection ou glisser-déposer)
  const uploadImages = (files) => {
    const images = Array.from(files).filter((f) => f.type.startsWith('image/'));
    if (images.length === 0) return;

    setFile((prev) => [...prev, ...images]);

    images.forEach((img) => {
      const reader = new FileReader();
      reader.onload = () => setImagereview((prev) => [...prev, reader.result]);
      reader.readAsDataURL(img);

      const formData = new FormData();
      formData.append('file', img);
      formData.append('upload_preset', 'r6s4af83'); // Remplacez par votre upload preset

      fetch('https://api.cloudinary.com/v1_1/dtrkcpsky/image/upload', {
        method: 'POST',
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => setCarsImages((prev) => prev + data.secure_url + ','))
        .catch((error) => console.error('Error uploading image:', error));
    });
  };

  const handleChangeImage = (e) => {
    uploadImages(e.target.files);
    e.target.value = ''; // permet de re-sélectionner le même fichier
  };

  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDragging(true);
  };

  const handleDragLeave = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) setIsDragging(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDragging(false);
    uploadImages(e.dataTransfer.files);
  };

  function handleSaveImage() {
    const envoyerRequete = async () => {
      const res = await axios.put('/vehicles/' + voitureId, {
        images: carsImages,
      });

      if (res.data) {
        toast.success('Images ajoutés avec succèss');
      }
    };

    envoyerRequete();
  }

  function handlePass() {
    window.location.href = '/completeAnnonce';
  }

  const currentStep = Math.max(displayArray.indexOf(true), 0);

  return (
    <main className="mc-home mc-form-page">
      <ToastContainer />

      <div className="mc-form-shell">
        <Stepper current={currentStep} />

        {/* ===================== ÉTAPE 1 — CARACTÉRISTIQUES ===================== */}
        {displayArray[0] === true && (
          <section className="mc-form-card">
            <span className="mc-section-kicker">VOTRE VÉHICULE</span>
            <h1 className="mc-form-title">Donnez plus de détails</h1>
            <p className="mc-form-subtitle">
              Ces caractéristiques aident les locataires à trouver la voiture qui leur convient.
            </p>

            <div className="mc-field">
              <span className="mc-field-label">Type de véhicule</span>
              <div className="mc-choice-row">
                <Choice
                  variant="mc-choice--card"
                  id="flexRadioDefaultUtilitaire"
                  name="flexRadioDefaultUtilitaire"
                  value="0"
                  checked={isUtilitaire === '0'}
                  onChange={handleIsUtilitaireChange}
                >
                  <ion-icon name="car-sport-outline"></ion-icon> Voiture
                </Choice>
                <Choice
                  variant="mc-choice--card"
                  id="flexRadioDefaultUtilitaire2"
                  name="flexRadioDefaultUtilitaire"
                  value="1"
                  checked={isUtilitaire === '1'}
                  onChange={handleIsUtilitaireChange}
                >
                  <ion-icon name="bus-outline"></ion-icon> Utilitaire
                </Choice>
              </div>
            </div>

            <div className="mc-grid-2">
              <div className="mc-field">
                <label className="mc-field-label" htmlFor="kilometrage">
                  Kilométrage
                </label>
                <select
                  id="kilometrage"
                  className="mc-select"
                  onChange={handleKmChange}
                  value={selectedKilometrage ?? ''}
                >
                  {KM_OPTIONS.map(([value, label]) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>

              <div className="mc-field">
                <label className="mc-field-label" htmlFor="carburant">
                  Carburant
                </label>
                <select
                  id="carburant"
                  className="mc-select"
                  onChange={handleCarburantChange}
                  value={selectedCarburant ?? ''}
                >
                  {FUEL_OPTIONS.map(([value, label]) => (
                    <option key={value} value={value}>
                      {label}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="mc-field">
              <span className="mc-field-label">Boîte de vitesse</span>
              <div className="mc-choice-row">
                <Choice
                  id="flexRadioDefault1"
                  name="flexRadioDefault"
                  value="0"
                  checked={vitesse === '0'}
                  onChange={handleSpeedChange}
                >
                  Manuelle
                </Choice>
                <Choice
                  id="flexRadioDefault2"
                  name="flexRadioDefault"
                  value="1"
                  checked={vitesse === '1'}
                  onChange={handleSpeedChange}
                >
                  Automatique
                </Choice>
              </div>
            </div>

            <div className="mc-field">
              <span className="mc-field-label">Nombre de portes</span>
              <div className="mc-choice-row">
                {DOOR_OPTIONS.map(([value, label]) => (
                  <Choice
                    key={value}
                    variant="mc-choice--square"
                    id={`control_0${value}`}
                    name="select"
                    value={value}
                    checked={nombrePorte === value}
                    onChange={handleNbPorteChange}
                  >
                    {label}
                  </Choice>
                ))}
              </div>
            </div>

            <div className="mc-field">
              <span className="mc-field-label">Nombre de sièges</span>
              <div className="mc-choice-row">
                {SEAT_OPTIONS.map(([value, label]) => (
                  <Choice
                    key={value}
                    variant="mc-choice--square"
                    id={`control_00${value}`}
                    name="siegeSelect"
                    value={value}
                    checked={nombreSiege === value}
                    onChange={handleSiegeChange}
                  >
                    {label}
                  </Choice>
                ))}
              </div>
            </div>

            <SafetyAlert />

            <div className="mc-form-actions">
              <button type="button" className="mc-btn mc-btn--secondary" onClick={handlePreced1}>
                <ion-icon name="arrow-back-outline"></ion-icon>
                Précédent
              </button>
              <button type="button" className="mc-btn mc-btn--primary" onClick={handleNext1}>
                Suivant
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
            </div>
          </section>
        )}

        {/* ===================== ÉTAPE 2 — OPTIONS ===================== */}
        {displayArray[1] === true && (
          <section className="mc-form-card">
            <span className="mc-section-kicker">ÉQUIPEMENTS</span>
            <h1 className="mc-form-title">Des options en plus ?</h1>
            <p className="mc-form-subtitle">
              Sélectionnez les équipements disponibles. Vous pouvez ne rien cocher.
            </p>

            <div className="mc-field">
              <div className="mc-choice-row">
                {EXTRA_OPTIONS.map(({ id, label, icon }) => (
                  <Choice
                    key={id}
                    type="checkbox"
                    variant="mc-choice--card"
                    id={`option-${id}`}
                    value={id}
                    checked={checkedOptions[Number(id) - 1]}
                    onChange={handleCheckBoxChange}
                  >
                    <ion-icon name={icon}></ion-icon> {label}
                  </Choice>
                ))}
              </div>
            </div>

            <SafetyAlert />

            <div className="mc-form-actions">
              <button type="button" className="mc-btn mc-btn--secondary" onClick={handlePreced2}>
                <ion-icon name="arrow-back-outline"></ion-icon>
                Précédent
              </button>
              <button type="button" className="mc-btn mc-btn--primary" onClick={handleNext2}>
                Suivant
                <ion-icon name="arrow-forward-outline"></ion-icon>
              </button>
            </div>
          </section>
        )}

        {/* ===================== ÉTAPE 3 — PHOTOS + FACTURATION ===================== */}
        {displayArray[2] === true && (
          <>
            <section className="mc-form-card">
              <span className="mc-section-kicker">PHOTOS</span>
              <h1 className="mc-form-title">Ajoutez des images</h1>
              <p className="mc-form-subtitle">
                Des photos nettes et lumineuses augmentent vos chances d'être réservé.
              </p>

              <label
                className={`mc-dropzone${isDragging ? ' is-dragging' : ''}`}
                onDragEnter={handleDragOver}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                onDrop={handleDrop}
              >
                <span className="mc-dropzone-icon">
                  <ion-icon name="cloud-upload-outline"></ion-icon>
                </span>
                <strong>{isDragging ? 'Déposez vos photos ici' : 'Glissez vos photos ici'}</strong>
                <span className="mc-dropzone-hint">
                  ou <u>parcourez vos fichiers</u> · JPG, PNG, WEBP ou TIFF
                </span>
                <input
                  accept="image/jpeg, image/tiff, image/webp, image/png"
                  type="file"
                  id="image"
                  multiple
                  onChange={handleChangeImage}
                />
              </label>

              {imagereview.length > 0 && (
                <>
                  <p className="mc-upload-count">
                    {imagereview.length} photo{imagereview.length > 1 ? 's' : ''} ajoutée
                    {imagereview.length > 1 ? 's' : ''}
                  </p>
                  <div className="mc-upload-grid">
                    {imagereview.map((src, i) => (
                      <div className="mc-upload-tile" key={i}>
                        <img src={src} alt={`Photo ${i + 1}`} />
                      </div>
                    ))}
                  </div>
                </>
              )}

              <button
                type="button"
                className="mc-btn mc-btn--secondary mc-upload-save"
                onClick={handleSaveImage}
                disabled={!carsImages}
              >
                <ion-icon name="checkmark-circle-outline"></ion-icon>
                Enregistrer les images
              </button>
            </section>

            <section className="mc-form-card">
              <span className="mc-section-kicker">PAIEMENTS</span>
              <h2 className="mc-form-title">Quelle est votre adresse de facturation ?</h2>

              <form onSubmit={handleSubmit}>
                <div className="mc-field">
                  <label className="mc-field-label" htmlFor="adresse">
                    Adresse
                  </label>
                  <input
                    id="adresse"
                    className="mc-input"
                    type="text"
                    placeholder="Ex : 95 rue Freetown Manama"
                    name="adresse"
                    value={formData.adresse}
                    onChange={handleChange}
                  />
                </div>

                <div className="mc-grid-2">
                  <div className="mc-field">
                    <label className="mc-field-label" htmlFor="codePostal">
                      Code postal
                    </label>
                    <input
                      id="codePostal"
                      className="mc-input"
                      type="text"
                      placeholder="Ex : 60000"
                      name="codePostal"
                      value={formData.codePostal}
                      onChange={handleChange}
                    />
                  </div>

                  <div className="mc-field">
                    <label className="mc-field-label" htmlFor="ville">
                      Ville
                    </label>
                    <input
                      id="ville"
                      className="mc-input"
                      type="text"
                      placeholder="Ex : Paris"
                      name="ville"
                      value={formData.ville}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="mc-grid-2">
                  <div className="mc-field">
                    <label className="mc-field-label" htmlFor="pays">
                      Pays
                    </label>
                    <select
                      id="pays"
                      className="mc-select"
                      name="pays"
                      value={formData.pays}
                      onChange={handleChange}
                    >
                      <option value="1">France</option>
                      <option value="2">Allemagne</option>
                      <option value="3">Espagne</option>
                    </select>
                  </div>

                  <div className="mc-field">
                    <label className="mc-field-label" htmlFor="numeroTelephone">
                      Numéro de téléphone
                    </label>
                    <input
                      id="numeroTelephone"
                      className="mc-input"
                      type="tel"
                      placeholder="Ex : 06 06 75 85 75"
                      name="numeroTelephone"
                      value={formData.numeroTelephone}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div className="mc-form-alert mc-form-alert--info" role="note">
                  <ion-icon name="information-circle-outline"></ion-icon>
                  <span>
                    Pour que vous receviez vos paiements, nous utilisons votre adresse de
                    facturation, votre numéro de téléphone et votre adresse e-mail. Vous pouvez les
                    modifier dans votre compte.
                  </span>
                </div>

                <div className="mc-form-actions">
                  <button
                    type="button"
                    className="mc-btn mc-btn--secondary"
                    onClick={handlePreced3}
                  >
                    <ion-icon name="arrow-back-outline"></ion-icon>
                    Précédent
                  </button>
                  <div className="mc-form-actions-end">
                    <button type="button" className="mc-btn mc-btn--ghost" onClick={handlePass}>
                      Passer
                    </button>
                    <button type="submit" className="mc-btn mc-btn--primary">
                      Confirmer
                      <ion-icon name="checkmark-outline"></ion-icon>
                    </button>
                  </div>
                </div>
              </form>
            </section>
          </>
        )}
      </div>
    </main>
  );
}

export default AdvancedConfigPage;
